import EventEmitter from "./utils/EventEmitter";

export default class ShortcutLinksPage extends EventEmitter {
    constructor(page) {
        super();

        this.page = page
        this.shortcutLinksContainer = this.page.querySelector('.shortcut-links-container')

        this.targets = Array.from(this.page.querySelectorAll('.shortcut-target'))

        this.populateShortcutLinks()
    }

    populateShortcutLinks() {
        // Si il n'y a aucune target, on supprime le container
        if (this.targets.length === 0 && this.shortcutLinksContainer) {
            this.shortcutLinksContainer.remove()
            return
        }

        this.targets.forEach((target) => {
            let link = document.createElement('a')
            link.classList.add('shortcut-link')
            link.setAttribute('href', `#${target.getAttribute('id')}`)
            link.innerHTML = target.innerHTML
            link.insertAdjacentHTML('beforeend', '<svg class="icon"><use xlink:href="#arrow-down"></use></svg>')

            this.shortcutLinksContainer.appendChild(link)
        })
    }

    events() {
        this.shortcutLinksContainer.addEventListener('click', (e) => {
            if (e.target.classList.contains('shortcut-link')) {
                e.preventDefault()
                let target = document.querySelector(e.target.getAttribute('href'))
                window.scrollTo({
                    top: target.offsetTop - 100,
                    behavior: 'smooth'
                })
            }
        })
    }

}
